<template>
  <div class="page-wrapper">
    <div class="login-card">

      <!-- Logo area -->
      <div class="logo-area">
        <div class="logo-circle">GNM</div>
        <h1 class="app-title">CRM</h1>
        <p class="app-subtitle">Welcome back</p>
      </div>

      <!-- Error message -->
      <div v-if="forEror" class="error-card">
        <svg class="error-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
        </svg>
        <span>{{ forEror }}</span>
      </div>

      <!-- Login form -->
      <form @submit.prevent="login" class="login-form">
        <div class="field-group">
          <label class="field-label" for="mainIn">Password</label>
          <div class="field-wrapper">
            <svg class="field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd" />
            </svg>
            <input
              type="password"
              id="mainIn"
              class="field-input"
              v-model="password"
              placeholder="Enter your password"
              autofocus
              autocomplete="off"
            />
          </div>
        </div>

        <button type="submit" class="login-btn" :disabled="loading">
          <span v-if="loading" class="btn-spinner"></span>
          <span v-else>Sign In</span>
        </button>
      </form>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "LoginView",

  data() {
    return {
      email: "",
      password: "",
      fade: true,
      username_special: "",
      blink: false,
      forEror: "",
      loading: false
    };
  },
  watch: {
    badAttemptToLogIn: function() {
      if (this.badAttemptToLogIn) {
        this.password = "";
        this.username_special = "";

        this.$store.commit("clients/setBadAttemptToLogIn", false);
        $(".dot").css("background-color", "red");
        this.forEror = this.errorInfo;
      } else {
        $(".dot").css("background-color", "red");
        this.forEror = this.errorInfo;
      }
      this.loading = false;
    },
    username_special: function() {
      if (this.username_special.length > 0) {
        $(".dot").css("visibility", "visible");
      }
    }
  },
  computed: {
    ...mapState("user", ["badAttemptToLogIn", "errorInfo"]),
    ...mapActions("user", ["loginAttempt", "getProfile"])
  },
  components: {},
  mounted() {
    let el = document.getElementById("mainIn");
    let dot = document.getElementsByClassName("dot");

    el.focus();
    el.onblur = function() {
      setTimeout(() => {
        $(".dot").css("visibility", "visible");
        el.focus();
      });
    };
  },

  methods: {
    login() {
      this.loading = true;
      this.forEror = "";
      const data = {
        username_special: this.password,
        password: this.password
      };
      this.$store.dispatch("user/loginAttempt", data).then(res => {
        this.$store.dispatch("user/getProfile").then(res => {
          this.$router.push("/clients1");
        });
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* Hidden dot kept for legacy jQuery targeting */
.dot {
  height: 8px;
  width: 8px;
  background-color: blue;
  border-radius: 50%;
  display: inline-block;
  visibility: hidden;
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* ── Full-page wrapper ── */
.page-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%);
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* ── Card ── */
.login-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-sizing: border-box;
}

/* ── Logo area ── */
.logo-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
}

.logo-circle {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.app-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px 0;
  letter-spacing: 1px;
}

.app-subtitle {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
  font-weight: 400;
}

/* ── Error card ── */
.error-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 24px;
  color: #dc2626;
  font-size: 14px;
  font-weight: 500;
}

.error-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* ── Form ── */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  opacity: 1;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  letter-spacing: 0.3px;
}

.field-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.field-icon {
  position: absolute;
  left: 14px;
  width: 18px;
  height: 18px;
  color: #94a3b8;
  pointer-events: none;
}

.field-input {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 16px 12px 44px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  color: #0f172a;
  background: #ffffff;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;

  &::placeholder {
    color: #cbd5e1;
  }

  &:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  }
}

/* ── Login button ── */
.login-btn {
  width: 100%;
  padding: 13px 16px;
  background: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;

  &:hover:not(:disabled) {
    background: #1d4ed8;
  }

  &:active:not(:disabled) {
    transform: scale(0.99);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

/* ── Loading spinner ── */
@keyframes spin {
  to { transform: rotate(360deg); }
}

.btn-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
</style>
